(function () {
    'use strict';

    angular
		.module('auditMandateEditModule')
		.directive('auditMandate', directive);

    directive.$inject = ['boxTmplScope', 'boxTmplHtml', 'boxTmplLinkFn'];

    function directive(boxTmplScope, boxTmplHtml, boxTmplLinkFn) {
        var directiveScope = _.clone(boxTmplScope);
        directiveScope.highlight = '=';

        return {
            scope: directiveScope,
            template: boxTmplHtml,
            controller: ['$rootScope', '$scope', '$controller', 'auditMandateService', 'permissionService',
                function ($rootScope, $scope, $controller, auditMandateService, permissionService) {
						     // Box template
						     $scope.baseTemplatePath = '/app/shared/auditMandate/auditMandate.[Template].tpl.html';

						     $scope.canEdit = permissionService.hasPermission('RecomGrpBusinessUnit_Recom_InternalAuditManagement', 'AuditMandate', 'Edit');

						     // Page is dirty
						     $scope.ctxtCtrl = {};
						     $scope.ctxtCtrl.needSaveChanges = false;

						     $controller('BoxTmplController', { $scope: $scope });
						 }],
            link: function (scope, elem, attrs) {

                boxTmplLinkFn(scope, elem, attrs);
            }
        }
    }
})();